import React, { useState } from 'react'
import stylesGlobal from '../../../styles/referral/global.module.css';
import clsx from 'clsx';
import Earnings from '../../../components/Header/MyEarnings/Earnings';
import FullPayoutHistory from '../../../components/PaymentHistory/FullPayoutHistory';

const PayoutHistory: React.FC = () => {


  return (
    <>
    <div className={clsx(stylesGlobal.container, stylesGlobal.gredintbox)}>
       <Earnings sticky={true} showCalender={true} title="Payout History" classAdd="noborder" />
        <FullPayoutHistory />
    </div>
    </>
  )
}

export default PayoutHistory;